import React from 'react';

// Cloud Backup state glyphs, shared by the Library's cloud column, its
// header progress line, and the app-wide BackupProgressToast. One cloud
// outline, four inner variants (Dropbox-style states):
//   check  — backed up (muted green)
//   up     — queued / uploading (accent blue; pair with .backup-pulse for
//            the row actively transferring)
//   down   — restoring (accent blue, arrow into the machine)
//   slash  — not backed up and no run is handling it (muted)
//   outline— neutral (column header, toast pill)
const INNER = {
    check: <path d="m9 13.5 2 2 4-4.5" />,
    up: <><path d="M12 17v-5" /><path d="m9.5 14 2.5-2.5 2.5 2.5" /></>,
    down: <><path d="M12 12v5" /><path d="m9.5 14.5 2.5 2.5 2.5-2.5" /></>,
    slash: <line x1="5" y1="4" x2="20" y2="19" />,
    outline: null,
};

export const CLOUD_STATE_COLORS = {
    check: 'rgba(120, 205, 150, 0.75)',
    up: 'var(--color-accent, #4CC2F1)',
    down: 'var(--color-accent, #4CC2F1)',
    slash: 'var(--color-text-tertiary)',
    outline: 'currentColor',
};

export default function CloudBackupGlyph({ variant = 'outline', size = 14, className, style, title }) {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={CLOUD_STATE_COLORS[variant] || 'currentColor'}
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            {title ? <title>{title}</title> : null}
            <path d="M20 17.6A4.5 4.5 0 0 0 17.5 9.4a6 6 0 0 0-11.6 1.6A4 4 0 0 0 6 19h11" />
            {INNER[variant] || null}
        </svg>
    );
}
